// extracted by mini-css-extract-plugin
export default {"component":"item_component__ou+QK","user":"item_user__QZNaJ","reward":"item_reward__mimdX"};